export default function () {
	return {
		modalName: null,
		endpointBase: null,
		currentId: null,
		customMethod: null
	}
}
